var FakeData =
[
  {
    "id": 1,
    "projectName":"Volunteer Network" , 
    "projectDescription": "A single page Application created  with React. where user can authenticated and apply for a social work user can pick the volunteering subject according to their choice. And can fix a voluntary service by using their google account. Admin can add or delete events and modify the volunteer list. Google sign in and dashboard was included in this project" , 
    "technology":{
      "tech1": "material-ui" ,
      "tech2": "mongoDb" ,
      "tech3": "Bootstrap" ,
      "tech4": "express" ,
      "tech5": "React" ,
      "tech6": "firebase" ,
    },
    "website": "https://volunteer-5d7fb.web.app/",
    "source": "https://github.com/Riyaz-khan-shuvo/volunteer-network",
    "img1": "https://i.postimg.cc/gr96Zr9T/v1.png",
    "img2": "https://i.postimg.cc/Kc1qBVSP/v2.png",
    "img3": "https://i.postimg.cc/FRWy79sM/v3.png",
    "cauroselId1":"carouselExampleControls0",
    "cauroselId":"#carouselExampleControls0",

  },
  {
    "id": 2,
    "projectName":"Travel Agency" , 
    "projectDescription": "A single page Application created  with React. where user can authenticated and apply for a social work user can pick their travailing place according to their choice" , 
    "technology":{
      "tech1": "material-ui" ,
      "tech2": "mongoDb" ,
      "tech3": "Bootstrap" ,
      "tech4": "express" ,
      "tech5": "React" ,
      "tech6": "firebase" ,
    },
    "website": "https://travel-agency-8e55c.web.app/",
    "source": "https://travel-agency-8e55c.web.app/",
    "img1": "https://i.postimg.cc/FR65jSV3/travel-1.png",
    "img2": "https://i.postimg.cc/R0MB9406/travel-2.png",
    "img3": "https://i.postimg.cc/cJXNL2KD/travel-3.png",
    "cauroselId1":"carouselExampleControls10",
    "cauroselId":"#carouselExampleControls10",

  },
  {
    "id": 3,
    "projectName":"Doctors Portal" , 
    "projectDescription": "A Single page Application created with react and with dashboard. Only Authenticated user can see the dashboard. where people can choice the date and time and fix an appointment. Any one doctor can review his appointments and prescribe medicine to a Patient from dashboard. Finally this is Online base Doctors & patient projects." , 
    "technology":{
      "tech1": "html" ,
      "tech2": "CSS" ,
      "tech3": "Bootstrap" ,
      "tech4": "JavaScript" ,
      "tech5": "React" ,
      "tech6": "firebase" ,
    },
    "website": "https://my-doctors-portal.web.app/",
    "source": "https://github.com/Riyaz-khan-shuvo/doctors-portal",
    "img1": "https://i.postimg.cc/qRRGm1fX/1.png",
    "img2": "https://i.postimg.cc/FKGZg26H/2.png",
    "img3": "https://i.postimg.cc/P57fpxXX/7-login-page.png",
    "cauroselId1":"carouselExampleControls",
    "cauroselId":"#carouselExampleControls",

  },
    {
      "id": 4,
      "projectName":"Travel Guru" , 
      "projectDescription": "A website for travelers. Users can Authenticate and only authenticated user can choose a place. Getting hotels for booking hotels by providing dates. Google map was included in this project.And this is a full responsive site" , 
      "technology":{
        "tech1": "html" ,
        "tech2": "CSS" ,
        "tech3": "Bootstrap" ,
        "tech4": "JavaScript" ,
        "tech5": "React" ,
        "tech6": "firebase" ,
      },
      "website": "https://travel-guru-f6f32.web.app/",
      "source": "https://github.com/Riyaz-khan-shuvo/travel-guru",
      "img1": "https://i.postimg.cc/VvxCmNgX/Home.png",
      "img2": "https://i.postimg.cc/FKN0Y74Z/Booking.png",
      "img3": "https://i.postimg.cc/K8KH0pkV/Search.png",
      "cauroselId1":"carouselExampleControls1",
      "cauroselId":"#carouselExampleControls1",

    },
    {
      "id": 5,
      "projectName":"Apartment Hunt" , 
      "projectDescription": "It's my first group project.My part was front-end design. The user can authenticate and users can book a house according to he/her choose. Only authenticate user can do these process. User can see the details of his/her choose home.  " , 
      "technology":{
        "tech1": "JavaScript" ,
        "tech2": "react" ,
        "tech3": "react-router" ,
        "tech4": "firebase" ,
        "tech5": "material-ui" ,
        "tech6": "mongo" ,
      },
      "website": "https://apartment-hunt-prac.web.app/",
      "source": "https://github.com/Riyaz-khan-shuvo/apartment-hunt-1",
      "img1": "https://i.postimg.cc/zvt2SpJ4/3.png",
      "img2": "https://i.postimg.cc/T1YHDBXr/4.png",
      "img3": "https://i.postimg.cc/cHWzsr9k/5.png",
      "cauroselId1":"carouselExampleControls2",
      "cauroselId":"#carouselExampleControls2",
    },
    {
      "id": 6,
      "projectName":"Creative Agency" , 
      "projectDescription": "A website for a software agency with responsive UI.  Authenticated users can order and check services.  An authenticated admin can add new services and new admin also. Admin can change order’s status to notify the clients about progress. " , 
      "technology":{
        "tech1": "javaScript" ,
        "tech2": "react" ,
        "tech3": "react-router" ,
        "tech4": "material-ui" ,
        "tech5": "firebase" ,
        "tech6": "mongo" ,
      },
      "website": "https://creative-agency-deee4.web.app/",
      "source": "https://github.com/Riyaz-khan-shuvo/creative-agency",
      "img1": "https://i.postimg.cc/hGfwy9MC/2-login.png",
      "img2": "https://i.postimg.cc/XJ5P34Rd/3-Customar-place-Order.png",
      "img3": "https://i.postimg.cc/P5qFJWGt/6-Admin-service-status.png",
      "cauroselId1":"carouselExampleControls3",
      "cauroselId":"#carouselExampleControls3",
      
    },
  ]
  export default FakeData;


  // {
  //   "id": 2,
  //   "projectName":"Hot-Gadgets" , 
  //   "projectDescription": "A Single Page E-Commerce Web Site Design." , 
  //   "technology":{
  //     "tech1": "html" ,
  //     "tech2": "CSS" ,
  //     "tech3": "Bootstrap" ,
  //     "tech4": "JavaScript" ,
  //   },
  //   "website": "https://riyaz-khan-shuvo.github.io/hot-gadgets/",
  //   "source": "https://github.com/Riyaz-khan-shuvo/hot-gadgets",
  //   "img1": "https://i.postimg.cc/8cXpGVkt/1.png",
  //   "img2": "https://i.postimg.cc/65SW1wmQ/2.png",
  //   "img3": "https://i.postimg.cc/4Nn45nwM/3.png",
  //   "cauroselId1":"carouselExampleControls1",
  //   "cauroselId":"#carouselExampleControls1",
  // },
  // {
  //   "id": 3,
  //   "projectName":"Panda e-commerce site" , 
  //   "projectDescription": "A Single Page E-Commerce Web Site Design & Full Responsive Design" , 
  //   "technology":{
  //     "tech1": "html" ,
  //     "tech2": "CSS" ,
  //     "tech3": "Bootstrap" ,
  //     "tech4": "JavaScript" ,
  //   },
  //   "website": "https://riyaz-khan-shuvo.github.io/e-commerce/",
  //   "source": "https://github.com/Riyaz-khan-shuvo/e-commerce",
  //   "img1": "https://i.postimg.cc/nhBJRmmd/1.png",
  //   "img2": "https://i.postimg.cc/GpR1ZpJb/2.png",
  //   "img3": "https://i.postimg.cc/m204yjPz/3.png",
  //   "cauroselId1":"carouselExampleControls2",
  //   "cauroselId":"#carouselExampleControls2",
    
  // },